import { isPositiveAmount, MONEY_EPSILON, toCents } from './money.js';
export function itemsReconciliation(input) {
    const kind = input.booked ? 'itemized' : 'estimate';
    const raw = input.booked ? input.price : input.budget;
    // A sourcing need with no budget has nothing to hold its items against;
    // a booked line always has a price, $0 included.
    const against = raw === null || (!input.booked && !isPositiveAmount(raw)) ? null : raw;
    if (against === null) {
        return { kind, total: input.itemsTotal, against: null, difference: null, state: 'none' };
    }
    const difference = (toCents(input.itemsTotal) - toCents(against)) / 100;
    const state = Math.abs(difference) <= MONEY_EPSILON ? 'match' : difference > 0 ? 'over' : 'under';
    return { kind, total: input.itemsTotal, against, difference, state };
}
/** A pasted amount: "$1,200.50", "1200.5", "1 200" — or null when it is not one. */
function readAmount(cell) {
    if (cell === undefined)
        return null;
    const cleaned = cell.replace(/[$€£₪,\s]/g, '');
    if (cleaned === '')
        return null;
    if (!/^-?\d+(\.\d+)?$/.test(cleaned))
        return null;
    const n = Number(cleaned);
    return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) / 100 : null;
}
/**
 * Rows pasted from a spreadsheet (tab-separated) or typed one per line, read
 * as item lines: **Item**, then optionally **Qty**, **Unit price** and
 * **Notes**, in that order. A first row whose quantity or price cell is a
 * word is a header and is skipped; a row with no item is skipped; a quantity
 * that is not a number is 1, and a price that is not one is $0 — so a paste
 * never fails, and what it could not read is plain on the grid to fix.
 */
export function parsePastedItems(text) {
    const lines = text
        .replace(/\r\n?/g, '\n')
        .split('\n')
        .filter((line) => line.trim() !== '');
    const rows = [];
    lines.forEach((line, index) => {
        const cells = line.split('\t').map((c) => c.trim());
        const [name, qtyCell, priceCell, notesCell] = cells;
        if (!name)
            return;
        const quantity = readAmount(qtyCell);
        const unitPrice = readAmount(priceCell);
        const isWord = (cell) => !!cell && /[a-z]/i.test(cell);
        const looksLikeHeader = index === 0 && (isWord(qtyCell) || isWord(priceCell));
        if (looksLikeHeader)
            return;
        rows.push({
            itemName: name.slice(0, 500),
            quantity: quantity !== null && quantity > 0 ? quantity : 1,
            unitPrice: unitPrice ?? 0,
            notes: notesCell ? notesCell.slice(0, 2000) : null,
        });
    });
    return rows;
}
//# sourceMappingURL=items.js.map